import { Box, keyframes, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import type { ByosScreenProps } from "../login-utils/types";

const cardIn = keyframes`
	from { opacity: 0; transform: translateY(8px) scale(0.98); }
	to   { opacity: 1; transform: translateY(0)   scale(1);    }
`;

const checkDraw = keyframes`
	from { stroke-dashoffset: 48; }
	to   { stroke-dashoffset: 0;  }
`;

const ringDraw = keyframes`
	from { stroke-dashoffset: 188; }
	to   { stroke-dashoffset: 0;   }
`;

export default function PollingSuccess(_props: ByosScreenProps) {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		const id = requestAnimationFrame(() => setMounted(true));
		return () => cancelAnimationFrame(id);
	}, []);

	return (
		<Stack
			sx={{
				gap: 2,
				alignItems: "center",
				textAlign: "center",
				py: 2,
				animation: mounted ? `${cardIn} 0.4s cubic-bezier(0.2, 0.8, 0.2, 1) both` : "none"
			}}
		>
			<Box
				component="svg"
				viewBox="0 0 80 80"
				width={72}
				height={72}
				sx={{ display: "block" }}
				aria-hidden="true"
			>
				<defs>
					<linearGradient id="successGrad" x1="0" y1="0" x2="1" y2="1">
						<stop offset="0%" stopColor="#02D5AB" />
						<stop offset="100%" stopColor="#0A7FA8" />
					</linearGradient>
				</defs>
				<circle
					cx="40"
					cy="40"
					r="30"
					fill="rgba(2, 213, 171, 0.08)"
					stroke="url(#successGrad)"
					strokeWidth="3"
					strokeLinecap="round"
					strokeDasharray="188"
					style={{
						animation: `${ringDraw} 0.55s cubic-bezier(0.4, 0, 0.2, 1) 0.05s both`
					}}
				/>
				<path
					d="M26 41 L36 51 L55 30"
					fill="none"
					stroke="url(#successGrad)"
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeDasharray="48"
					style={{
						animation: `${checkDraw} 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.5s both`
					}}
				/>
			</Box>

			<Stack sx={{ gap: 0.5, alignItems: "center" }}>
				<Typography
					sx={{
						fontSize: 22,
						fontWeight: 600,
						color: "rgba(13, 31, 48, 0.92)",
						letterSpacing: "-0.01em"
					}}
				>
					You're signed in
				</Typography>
				<Typography
					sx={{
						fontSize: 14,
						color: "rgba(13, 31, 48, 0.55)",
						lineHeight: 1.55,
						maxWidth: 320
					}}
				>
					You can close this tab and head back to the window where you started.
				</Typography>
			</Stack>
		</Stack>
	);
}
